import { render, staticRenderFns } from "./CartDetailsLine.vue?vue&type=template&id=b28e1ed6&scoped=true&"
import script from "./CartDetailsLine.vue?vue&type=script&lang=js&"
export * from "./CartDetailsLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28e1ed6",
  null
  
)

export default component.exports